import React, { useState } from "react"
import Pagination from "../Pagination/pagination"
import {
  results,
  resultsTop,
  resultsContainer,
  listResult,
} from "./listResults.module.scss"
import PropTypes from "prop-types"
import { Infos } from "./results-taxo-styled"
import SearchFadeIn from "../search-fade-in"
import ResultItem from "./ResultItem/result-item"
import SearchFilters from "../search-filters"

//-----------------------Parent component---------------------------//

const ResultsTaxo = ({ resultats, pageContext }) => {
  const { currentPage, numPages, baseLink, slugTerm, nodesLength } = pageContext
  let tabType = []
  resultats.map(({ node }) => {
    tabType.push(node.internal.type)
    tabType = [...new Set(tabType)]
    return null
  })
  const [choosenType, setChoosenType] = useState(null)

  const toggleType = (typeChoisi, nameType) => {
    if (typeChoisi === nameType) {
      setChoosenType(null)
    } else {
      setChoosenType(nameType)
    }
  }

  if (choosenType !== null) {
    resultats = resultats.filter(({ node }) => {
      if (node.internal.type === choosenType) {
        return true
      }
      return false
    })
  }
  return (
    <section className={results}>
      <div className={resultsTop}>
        <Infos>
          {nodesLength} résultat(s) pour le terme &quot;{slugTerm}&quot;
        </Infos>
        <Pagination
          currentPage={currentPage}
          numPages={numPages}
          contextPage={baseLink}
        />
      </div>
      <SearchFilters
        tabType={tabType}
        choosenType={choosenType}
        toggleType={toggleType}
      />
      <div className={resultsContainer}>
        {resultats.length === 0 && (
          <div>Pas de résultats, veuillez modifier votre requête</div>
        )}
        <SearchFadeIn delay={150}>
          <ul id="list-result" role="listbox" className={listResult}>
            {resultats.map(({ node }, index) => {
              return (
                <ResultItem key={node.drupal_id} result={node} index={index} />
              )
            })}
          </ul>
        </SearchFadeIn>
        <Pagination
          currentPage={currentPage}
          numPages={numPages}
          contextPage={baseLink}
        />
      </div>
    </section>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Prop-Types---------------------------//

ResultsTaxo.propTypes = {
  resultats: PropTypes.array,
  pageContext: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default ResultsTaxo
